module.exports = __webpack_public_path__ + "img/safe-left-bottom.bd69dda6.png";